import {Component, HostBinding, OnInit, OnDestroy} from '@angular/core';
import {StompRService} from '@stomp/ng2-stompjs';
import {Subscription} from 'rxjs';
import {Message} from '@stomp/stompjs';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {UserAware, UserAwareBase} from './domain/model/user/user-aware.class';
import {applyMixins} from './common/mixins/mixins.util';
import {AuthService} from './components/security/authorization/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {AutoLogoutService} from './components/security/autologout/auto-logout.service';
import {WebsocketService} from './components/websocket/websocket.service';

@Component({
    selector: 'my-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')],
})
export class AppComponent extends UserAware(UserAwareBase) implements OnDestroy, OnInit {
    @HostBinding('class.logged-in') loggedIn: boolean = false;
    STATIC_WEBSOCKET_URL: string = process.env.STOMP_URI || '';
    private subscriptions: Subscription[] = [];
    private wsConnected: boolean = false;
    private wsConnection: StompRService;
    private wsSubscription: Subscription;

    constructor(
        protected authService: AuthService,
        protected autoLogoutService: AutoLogoutService,
        protected router: Router,
        protected toastyService: ToastyService,
        protected wsService: WebsocketService,
    ) {
        super(authService);
        this.subscriptions.forEach(it => it.unsubscribe());
        this.subscriptions = [];
        router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            $('.content-wrapper').animate({scrollTop: 0}, 200);
        });
        this.connectWebSocket();
        autoLogoutService.start();
    }

    ngOnInit() {
        this.userIsLoggedIn$.subscribe(value => {
            this.loggedIn = value;
        });
    }

    ngOnDestroy(): void {
        this.disposeSubscriptions();
    }

    connectWebSocket() {
        this.wsConnection = this.wsService.getWebSocket(this.STATIC_WEBSOCKET_URL);
        this.subscriptions.push(this.handleWSConnectionSuccess());
    }

    public handleWSConnectionSuccess(): Subscription {
        return this.wsConnection.connectObservable.subscribe(() => {
            if (!this.wsConnected) {
                this.wsConnected = true;
                this.subscriptions.push(this.getUserAndSubscribeToWebsocket());
            }
        });
    }

    getUserAndSubscribeToWebsocket(): Subscription {
        return this._authService.user$
            .filter(user => user !== undefined)
            .subscribe(user => {
                if (user && !this.wsSubscription) {
                    let remoteId = user.id.substr(user.id.lastIndexOf('/') + 1);
                    this.wsSubscription = this.handleWSIncomingMessages(remoteId);
                }
            });
    }

    handleWSIncomingMessages(remoteId): Subscription {
        return this.wsConnection.subscribe(`/user/${remoteId}/topic/prepare-zip-completed`)
            .map((message: Message) => {
                return message.body;
            }).subscribe((msg_body: string) => {
                if (msg_body === 'COMPLETED') {
                    this.showZipCompletedToast();
                }
            });
    }

    disposeSubscriptions(): void {
        if (this.subscriptions.length) {
            this.subscriptions.forEach(it => it.unsubscribe());
            this.subscriptions = [];
        }
        if (this.wsSubscription && !this.wsSubscription.closed) this.wsSubscription.unsubscribe();
        if (this.wsConnection) this.wsConnection.disconnect();
    }

    private showZipCompletedToast() {
        const toastOptions: ToastOptions = {
            title: 'Your download is ready',
            msg: '<a href="/documents">Your download request has been processed, get it in your documents page.</a>',
            showClose: true,
            timeout: 60000,
            theme: 'bootstrap'
        };
        this.toastyService.success(toastOptions);
    }
}

applyMixins(AppComponent, [UserAware]);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts